import { render, staticRenderFns } from "./MerchantInfo.vue?vue&type=template&id=c0dddbd0&scoped=true&"
import script from "./MerchantInfo.vue?vue&type=script&lang=js&"
export * from "./MerchantInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dddbd0",
  null
  
)

export default component.exports